import React from "react";
import { cn } from "@/lib/utils";

export function BillingPageState({
  text,
  tone = "default",
}: {
  text: string;
  tone?: "default" | "error";
}) {
  return (
    <div
      className={cn(
        "border-base-border rounded-xl border bg-white p-6 text-sm text-black/65 shadow-sm",
        tone === "error" &&
          "border-custom-destructive-dark/40 bg-custom-destructive-dark/5 text-custom-destructive-dark",
      )}
    >
      {text}
    </div>
  );
}
